import { countBy, toInteger } from "lodash";
import moment from "moment";

/**
 * 指定した西暦の年月日をge.mm.dd文字列に変換する
 * @param {date} target - 変換するDateオブジェクト
 * @param {*} digit 和暦年桁数（1:1年/2:01年）
 * @param {*} eradigit 元号桁数（1:令和/2:R）
 * @returns ge.mm.dd
 *  */
export function convert_to_gemmdd(target, digit, eradigit) {
  try {
    let eras = [
      { year: 2018, jp: "令和", en: "R" },
      { year: 1988, jp: "平成", en: "H" },
      { year: 1925, jp: "昭和", en: "S" },
      { year: 1911, jp: "大正", en: "T" },
      { year: 1867, jp: "明治", en: "M" },
    ];
    let eraNum;
    if (
      moment(target, "YYYY/MM/DD").isSameOrAfter(
        moment("2019/5/1", "YYYY/MM/DD")
      )
    ) {
      // 令和：2019/5/1～
      eraNum = 0;
    } else if (
      moment(target, "YYYY/MM/DD").isBefore(moment("1912/7/30", "YYYY/MM/DD"))
    ) {
      // 明治：1868/1/25～1912/7/29
      eraNum = 4;
    } else if (
      moment(target, "YYYY/MM/DD").isBefore(moment("1926/12/25", "YYYY/MM/DD"))
    ) {
      // 大正：1912/7/30～1926/12/24
      eraNum = 3;
    } else if (
      moment(target, "YYYY/MM/DD").isBefore(moment("1989/1/8", "YYYY/MM/DD"))
    ) {
      // 昭和：1926/12/25～1989/1/7
      eraNum = 2;
    } else if (
      moment(target, "YYYY/MM/DD").isBefore(moment("2019/5/1", "YYYY/MM/DD"))
    ) {
      // 平成：1989/1/8～2019/4/30
      eraNum = 1;
    } else {
      console.log("convert_to_gemmdd : 元号不明の日付です", target);
    }

    let era;
    switch (eradigit) {
      case 1:
        era = eras[eraNum].jp;
        break;
      case 2:
        era = eras[eraNum].en;
        break;
      default:
        console.log("convert_to_gemmdd : 無効なeradigitです", eradigit);
        break;
    }

    switch (digit) {
      case 1:
        return (
          era +
          (target.getFullYear() - eras[eraNum].year) +
          "." +
          String(target.getMonth() + 1) +
          "." +
          String(target.getDate())
        );
      case 2:
        return (
          era +
          String(target.getFullYear() - eras[eraNum].year).padStart(2, 0) +
          "." +
          String(target.getMonth() + 1).padStart(2, 0) +
          "." +
          String(target.getDate()).padStart(2, 0)
        );
      default:
        console.log("convert_to_gemmdd : 無効なdigitです", digit);
        break;
    }
  } catch (error) {
    console.log("convert_to_gemmdd : 日付変換エラー", error);
    return target;
  }
}

/**
 * 指定した西暦の年月日をge.mm.dd文字列に変換する
 * @param {date} target - 変換するDateオブジェクト
 * @param {*} digit 和暦年桁数（1:1年/2:01年）
 * @param {*} eradigit 元号桁数（1:令和/2:R）
 * @returns ge/mm/dd
 *  */
export function convert_to_gemmddCharacters(target, digit, eradigit) {
  var gemmdd = convert_to_gemmdd(target, digit, eradigit);
  gemmdd = gemmdd.replace(".", "年");
  gemmdd = gemmdd.replace(".", "月");
  return gemmdd + "日";
}
/**
 * 西暦 => 和暦
 * @param {*} year 転換元
 * @param {*} digit 和暦年桁数（1:1年/2:01年）
 * @param {*} fiscaldigit 年号桁数（1:年/2:年度）
 * @returns 転換後和暦文字列
 */
export function wareki(year, digit, fiscaldigit) {
  // パラメータ設定
  var digit = arguments[1] ? arguments[1] : 1;
  var fiscaldigit = arguments[2] ? arguments[2] : 2;
  // 0補足
  var addZero = digit == 1 ? false : true;
  // 年/年度
  var nendo = fiscaldigit == 1 ? "年" : "年度";

  var eras = [
    { year: 2018, name: "令和" },
    { year: 1988, name: "平成" },
    { year: 1925, name: "昭和" },
    { year: 1911, name: "大正" },
    { year: 1867, name: "明治" },
  ];

  if (year === 2019) {
    if (addZero) {
      return "平成31(令和01)" + nendo;
    } else {
      return "平成31(令和1)" + nendo;
    }
  }
  for (const i in eras) {
    const era = eras[i];
    const baseYear = era.year;
    const eraName = era.name;

    if (year > baseYear) {
      var eraYear = year - baseYear;
      if (addZero) {
        eraYear = (Array(2).join(0) + eraYear).slice(-2);
      }
      return `${eraName}${eraYear}` + nendo;
    }
  }
  return null;
}

/**
 * 西暦 => 元号
 * @param {*} year 西暦年
 * @returns {元号、年}
 */
export function yearToWareki(year) {
  var eras = [
    { year: 2018, name: "令和" },
    { year: 1988, name: "平成" },
    { year: 1925, name: "昭和" },
    { year: 1911, name: "大正" },
    { year: 1867, name: "明治" },
  ];

  for (const i in eras) {
    const era = eras[i];
    const baseYear = era.year;
    const eraName = era.name;

    if (year > baseYear) {
      var eraYear = year - baseYear;
      let result = { name: `${eraName}`, year: `${eraYear}` };
      return result;
    }
  }
  return null;
}

/**
 * 和暦 => 西暦
 * @param {*} warekiYear 和暦
 * @returns 西暦文字列
 */
export function seireki(warekiYear) {
  let matches = warekiYear.match(
    "^(明治|大正|昭和|平成|令和)([元0-9０-９]+)年$"
  );

  if (matches) {
    let eraName = matches[1];
    let year = parseInt(
      matches[2].replace(/[元０-９]/g, function (match) {
        if (match === "元") {
          return 1;
        }
        return String.fromCharCode(match.charCodeAt(0) - 65248);
      })
    );

    if (eraName === "明治") {
      year += 1867;
    } else if (eraName === "大正") {
      year += 1911;
    } else if (eraName === "昭和") {
      year += 1925;
    } else if (eraName === "平成") {
      year += 1988;
    } else if (eraName === "令和") {
      year += 2018;
    }
    return `${year}年`;
  }
  return null;
}

/**
 * 和暦 => 西暦年計算
 * @param {*} reki 和暦
 * @param {*} year 和暦年
 * @returns 西暦年
 */
export function warekiToYear(reki, year) {
  if ((reki == "令和" || reki == 0) && year > 0) {
    return parseInt(year) + 2018;
  } else if ((reki == "平成" || reki == 1) && year > 0 && year <= 31) {
    return parseInt(year) + 1988;
  } else if ((reki == "昭和" || reki == 2) && year > 0 && year <= 64) {
    return parseInt(year) + 1925;
  } else if ((reki == "大正" || reki == 3) && year > 0 && year <= 15) {
    return parseInt(year) + 1911;
  } else if ((reki == "明治" || reki == 4) && year > 0 && year <= 45) {
    return parseInt(year) + 1867;
  } else {
    return 0;
  }
}

/**
 * Date判定
 * @param {*} dateValue 入力値
 * @returns チェック結果 true  : チェックOK / false : チェックNG
 */
export function verifyDate(dateValue) {
  const regex = new RegExp(
    "^(?:(?:([0-9]{4}(.|-|/)(?:(?:0?[1,3-9]|1[0-2])(.|-|/)(?:29|30)|((?:0?[13578]|1[02])(.|-|/)31)))|([0-9]{4}(.|-|/)(?:0?[1-9]|1[0-2])(.|-|/)(?:0?[1-9]|1\\d|2[0-8]))|(((?:(\\d\\d(?:0[48]|[2468][048]|[13579][26]))|(?:0[48]00|[2468][048]00|[13579][26]00))(.|-|/)0?2(.|-|/)29))))$"
  );
  if (!regex.test(dateValue)) {
    return false;
  } else {
    return true;
  }
}

/**
 * 月判定
 * @param {*} dateValue 入力値
 * @returns チェック結果 true  : チェックOK / false : チェックNG
 */
export function verifyMonth(dateValue) {
  if (dateValue > 12 || dateValue < 1) {
    return false;
  }
  return true;
}

/**
 * 日付判定
 * @param {*} year 年
 * @param {*} month 月
 * @param {*} day 日
 * @returns チェック結果 true  : チェックOK / false : チェックNG
 */
export function isDate(year, month, day) {
  if (isNaN(year) || isNaN(month) || isNaN(day)) return false;

  if (month > 12 || month < 1) return false;

  if (day > 31 || day < 1) return false;

  if ((month == 4 || month == 6 || month == 9 || month == 11) && day > 30)
    return false;

  if (month == 2) {
    if (day > 29) return false;
    if (((year % 100 == 0 && year % 400 != 0) || year % 4 != 0) && day > 28) {
      return false;
    }
  }
  return true;
}

/**
 * 西暦閾値判定
 * @param {*} reki 和暦
 * @param {*} year 年
 * @param {*} month 月
 * @param {*} day 日
 * @returns チェック結果 true  : チェックOK / false : チェックNG
 */
export function warekisikiiChk(reki, year, month, day) {
  if (isNaN(reki) || isNaN(year) || isNaN(month) || isNaN(day)) return false;

  if (reki == 1) {
    //1:平成　31年４月30日まで
    //令和元年以降チェック
    if (year == 31) {
      if (month >= 5) {
        if (day >= 1) return false;
      }
    }

    if (year > 31 || year < 1) {
      return false;
    }
  }
  if (reki == 0) {
    //0:令和　元年5月1日から
    //令和元年チェック
    if (year == 1 && month <= 4) {
      return false; // 令和
    }

    if (year < 1) {
      return false;
    }
  }
  return true;
}

/**
 * 和暦年判定
 * @param {*} reki 和暦
 * @param {*} year 年
 * @returns チェック結果 true  : チェックOK / false : チェックNG
 */
export function warekiYearChk(reki, year) {
  if (isNaN(reki) || isNaN(year)) {
    return false;
  }

  switch (reki) {
    case 0:
      //令和
      if (year < 1) {
        return false;
      }
      break;

    case 1:
      //平成
      if (year < 1 || year > 31) {
        return false;
      }
      break;

    case 2:
      // 昭和
      if (year < 1 || year > 64) {
        return false;
      }
      break;

    case 3:
      // 大正
      if (year < 1 || year > 15) {
        return false;
      }
      break;

    case 4:
      // 明治
      if (year < 1 || year > 45) {
        return false;
      }
      break;

    default:
      return false;
  }

  return true;
}

/**
  和暦形式の日付をグレゴリオ暦形式に変換します。
  @param {string} reki - 日付の元号 (0: 令和, 1: 平成, 2: 昭和, 3: 大正, 4: 明治)。
  @param {string} year - 日付の年。
  @param {string} month - 日付の月。
  @param {string} day - 日付の日。
  @returns {string} - グレゴリオ暦形式の日付 (YYYY-MM-DD 00:00:00)、または無効な入力の場合は空の文字列。
*/
export function toGregorianCalendarDateString(reki, year, month, day) {
  let numberReki = Number(reki);
  let numberYear = Number(year);
  let numberMonth = Number(month);
  let numberDay = Number(day);
  if (warekiDateChk(numberReki, numberYear, numberMonth, numberDay)) {
    let ADYear = 0;
    switch (numberReki) {
      case 0:
        ADYear = 2018 + numberYear;
        break;
      case 1:
        ADYear = 1988 + numberYear;
        break;
      case 2:
        ADYear = 1925 + numberYear;
        break;
      case 3:
        ADYear = 1911 + numberYear;
        break;
      case 4:
        ADYear = 1867 + numberYear;
        break;
    }
    return `${zeroPad(ADYear, 4)}-${zeroPad(numberMonth, 2)}-${zeroPad(
      numberDay,
      2
    )} 00:00:00`;
  } else {
    return "";
  }
}

/**
  数値を指定された桁数になるようにゼロパディングします。
  @param {number} num - ゼロパディングする数値。
  @param {number} digit - 桁数。
  @returns {string} - ゼロパディングされた文字列。
*/
function zeroPad(num, digit) {
  const strNum = num.toString();
  if (strNum.length < digit) {
    return "0".repeat(digit - strNum.length) + strNum;
  } else {
    return strNum;
  }
}

/**
 * 和暦の年号有効期限チェック
 * @param {number} reki 年号 0:令和、1:平成、2:昭和、3:大正、4:明治
 * @param {number} year 任意元年から数えた和暦年（数字）
 * @param {number} month 月（数字）
 * @param {number} day 日（数字）
 * @returns {boolean} {string} チェック結果 true : YYYY/MM/DD形式の日付 / false : ""
 */
export function warekiDateChk(reki, year, month, day) {
  let numberReki = Number(reki);
  let numberYear = Number(year);
  let numberMonth = Number(month);
  let numberDay = Number(day);
  // 全て数字でない場合はfalseを返す
  if (
    isNaN(numberReki) ||
    isNaN(numberYear) ||
    isNaN(numberMonth) ||
    isNaN(numberDay)
  )
    return false;

  // 年月日が0の場合はfalseを返す
  if (numberYear == 0 || numberMonth == 0 || numberDay == 0) return false;

  switch (numberReki) {
    // 令和
    case 0:
      if (numberYear < 1) {
        return false;
      } else if (
        (numberYear === 1 && numberMonth < 5) ||
        (numberYear === 1 && numberMonth === 5 && numberDay < 1)
      ) {
        return false;
      }
      break;

    // 平成
    case 1:
      if (numberYear < 1 || numberYear > 31) {
        return false;
      } else if (
        (numberYear === 1 && numberMonth < 1) ||
        (numberYear === 1 && numberMonth === 1 && numberDay < 8) ||
        (numberYear === 31 && numberMonth > 4) ||
        (numberYear === 31 && numberMonth === 4 && numberDay > 30)
      ) {
        return false;
      }
      break;

    // 昭和
    case 2:
      if (numberYear < 1 || numberYear > 64) {
        return false;
      } else if (
        (numberYear === 1 && numberMonth < 12) ||
        (numberYear === 1 && numberMonth === 12 && numberDay < 25) ||
        (numberYear === 64 && numberMonth > 1) ||
        (numberYear === 64 && numberMonth === 1 && numberDay > 7)
      ) {
        return false;
      }
      break;

    // 大正
    case 3:
      if (numberYear < 1 || numberYear > 15) {
        return false;
      } else if (
        (numberYear === 1 && numberMonth < 7) ||
        (numberYear === 1 && numberMonth === 7 && numberDay < 30) ||
        (numberYear === 15 && numberMonth > 12) ||
        (numberYear === 15 && numberMonth === 12 && numberDay > 25)
      ) {
        return false;
      }
      break;

    // 明治
    case 4:
      if (numberYear < 1 || numberYear > 45) {
        return false;
      } else if (
        (numberYear === 1 && numberMonth < 10) ||
        (numberYear === 1 && numberMonth === 10 && numberDay < 23) ||
        (numberYear === 45 && numberMonth > 7) ||
        (numberYear === 45 && numberMonth === 7 && numberDay > 29)
      ) {
        return false;
      }
      break;

    default:
      return false;
  }

  const gregorianYear = warekiToYear(numberReki, numberYear);
  if (numberMonth < 1 || numberMonth > 12) {
    return false;
  } else if (
    numberDay < 1 ||
    numberDay > 31 ||
    ((numberMonth === 4 ||
      numberMonth === 6 ||
      numberMonth === 9 ||
      numberMonth === 11) &&
      numberDay > 30) ||
    (numberMonth === 2 &&
      (numberDay > 29 ||
        (((gregorianYear % 100 == 0 && gregorianYear % 400 != 0) ||
          gregorianYear % 4 != 0) &&
          numberDay > 28)))
  ) {
    return false;
  }

  return true;
}

const eraStartMonth = {
  令和: 5,
  平成: 1,
  昭和: 12,
  大正: 7,
  明治: 1,
};

const eraStartDay = {
  令和: 1,
  平成: 8,
  昭和: 25,
  大正: 30,
  明治: 25,
};

const eraStart = {
  令和: 2019,
  平成: 1989,
  昭和: 1926,
  大正: 1912,
  明治: 1868,
};

/**
  日付文字列を和暦形式に変換します。
  @param {string} dateString - 日付文字列。
  @returns {object} - 和暦形式の日付オブジェクト (元号、年、月、日)、または空の文字列。
*/
export function convertDateToWareki(dateString) {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "";
  }

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  let wareki;
  if (moment(date).isSameOrAfter(new Date("2019-05-01T00:00:00+09:00"))) {
    wareki = "令和";
  } else if (
    moment(date).isSameOrAfter(new Date("1989-01-08T00:00:00+09:00"))
  ) {
    wareki = "平成";
  } else if (
    moment(date).isSameOrAfter(new Date("1926-12-25T00:00:00+09:00"))
  ) {
    wareki = "昭和";
  } else if (
    moment(date).isSameOrAfter(new Date("1912-07-30T00:00:00+09:00"))
  ) {
    wareki = "大正";
  } else if (
    moment(date).isSameOrAfter(new Date("1868-10-23T00:00:00+09:00"))
  ) {
    wareki = "明治";
  }

  if (
    !wareki ||
    (year == eraStart[wareki] &&
      (month < eraStartMonth[wareki] ||
        (month == eraStartMonth[wareki] && day < eraStartDay[wareki]))) ||
    date <
      new Date(eraStart[wareki], eraStartMonth[wareki] - 1, eraStartDay[wareki])
  ) {
    return "";
  }

  const eraStartYear = eraStart[wareki];
  const yearInEra = year - eraStartYear + 1;

  return { wareki, year: yearInEra, month, day };
}

/**
 * DateオブジェクトをISO8601表記に変換
 * DateオブジェクトをAPIに渡す際は必ず使用すること
 * @param {*} date Dateオブジェクト
 * @returns ISO8601表記
 */
export function formatISO8601(date) {
  // var offset = (function (d) {
  //   var o = d.getTimezoneOffset() / -60;
  //   return (0 < o ? "+" : "-") + ("0" + Math.abs(o)).slice(-2) + ":00";
  // })(date);
  // 2023/09/26 13:01:13 IPメッセージ 指摘 UTCオフセットを9時間固定
  const offset = "+09:00";
  const result = [

    [
      date.getFullYear(),
      ("0" + (date.getMonth() + 1)).slice(-2),
      ("0" + date.getDate()).slice(-2),
    ].join("-"),
    "T",
    [
      ("0" + date.getHours()).slice(-2),
      ("0" + date.getMinutes()).slice(-2),
      ("0" + date.getSeconds()).slice(-2),
    ].join(":"),
    offset,
  ].join("");
  return result;
}
